import React from 'react'
import { Link } from 'react-router-dom'
import ssnBlanco from "../../img/ssnBlanco.png";
import { HashLink } from 'react-router-hash-link';

const Footer = ({setModalBalances}) => {

   return (
      <>
         <footer className="page-footer grey darken-4">
            <div className="container section">
               <div className="row">
                  <div className="col s12 m12 l3">
                     <p className="grey-text text-darken-1 uppercase">menu</p>
                     <ul>
                        <li><Link className="grey-text text-lighten-3" to="/"><strong>Inicio</strong></Link></li>
                        <li><Link className="grey-text text-lighten-3" to="/institucional"><strong>Institucional</strong></Link></li>
                        <li><Link className="grey-text text-lighten-3" to="/seguros"><strong>Seguros</strong></Link></li>
                        <li><Link className="grey-text text-lighten-3" to="/normativa"><strong>Normativa</strong></Link></li>
                        <li><Link className="grey-text text-lighten-3" to="/compromiso"><strong>Compromiso</strong></Link></li>
                     </ul>
                  </div>
                  <div className="col s12 m12 l3">
                     <p className="grey-text text-darken-1 uppercase">descargas</p>
                     <ul>
                        <li><HashLink className="grey-text text-lighten-3" to={"/descargas#seccionPrestadores"}><strong>Prestadores</strong></HashLink></li>
                        <li><HashLink className="grey-text text-lighten-3" to={"/descargas#seccionContratos"}><strong>Contratos</strong></HashLink></li>
                        <li><HashLink className="grey-text text-lighten-3" to={"/descargas#seccionPrevencion"}><strong>Prevención</strong></HashLink></li>
                        <li><HashLink className="grey-text text-lighten-3" to={"/descargas#seccionSiniestros"}><strong>Siniestros</strong></HashLink></li>
                     </ul>
                  </div>
                  <div className="col s12 m12 l4">
                     <p className="grey-text text-darken-1 uppercase">información útil</p>
                     <ul>
                        <li><Link className="grey-text text-lighten-3" to="/servicioDeAtencion"><strong>Servicio de Atención al Asegurado</strong></Link></li>
                        <li><Link className="grey-text text-lighten-3" to="/consultasReclamos"><strong>Consulta y Reclamos</strong></Link></li>
                        <li><Link className="grey-text text-lighten-3" to="/faq"><strong>Preguntas Frecuentes</strong></Link></li>
                        <li><Link className="grey-text text-lighten-3" to="/pagoPoliza"><strong>Pago Póliza Automotor</strong></Link></li>
                     </ul>
                  </div>
                  <div className="col s12 m12 l2">
                     <p className="grey-text text-darken-1 uppercase">nosotros</p>
                     <ul>
                        <li><Link className="grey-text text-lighten-3" to="/rrhh"><strong>Dejanos tu CV</strong></Link></li>
                        <li><Link className="grey-text text-lighten-3" to="/contacto"><strong>Contacto</strong></Link></li>
                        <li><Link className="grey-text text-lighten-3" onClick={()=>{setModalBalances("active");}}><strong>Balances</strong></Link></li>
                     </ul>
                  </div>
               </div>
               <div className="row">
                  <div className="col s12 m12 l12 justify" style={{"font-size":"10px"}}>
                     La entidad aseguradora dispone de un Servicio de Atención al Asegurado que atenderá las consultas y reclamos 
                     que presenten los tomadores de seguros, asegurados, beneficiarios y/o derechohabientes. 
                     El Servicio de Atención al Asegurado está integrado por: 
                     Responsable: Ramiro Javier Montero, Tel. 0388 - 4911741 Int.: 302, e-mail: rmontero@latitudsursa.com.ar, 
                     Suplente: José Prudencio Gutiérrez, Tel. 0388 - 4911741 Int.: 127, e-mail: jgutierrez@latitudsursa.com.ar. 
                     En caso de que existiera un reclamo ante la entidad aseguradora y que el mismo no haya sido resuelto o 
                     haya sido desestimado, total o parcialmente, o que haya sido denegada su admisión, podrá comunicarse 
                     con la Superintendencia de Seguros de la Nación a través del sitio web oficial <a href="https://www.argentina.gob.ar/ssn" target="blank"> argentina.gob.ar/ssn</a>.
                  </div>
               </div>
            </div>
            <div>
               <div className="divider"></div>
            </div>
            <div className=" section">
               <div className="row">
                  <div className="col s3 m3 l3 center">N° de inscripcion en SSN<br/>0412</div>
                  <div className="col s3 m3 l3 center">Atención al Asegurado<br/>0800-199-0023</div>
                  <div className="col s3 m3 l3 center">Organismo de control<br/><Link to="https://www.argentina.gob.ar/superintendencia-de-seguros"  target="_blank">www.argentina.gob.ar/ssn</Link></div>
                  <Link to="https://www.argentina.gob.ar/superintendencia-de-seguros"  target="_blank"><img className="responsive-img" src={ssnBlanco} width="250px"/></Link>
               </div>
            </div>
            <div className="footer-copyright grey darken-3">
               <div className="container">
               © 2026 Latitud Sur S.A. ·
               </div>
            </div>
         </footer>
      </>
   )
}

export default Footer